var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 647,
    height: 783,
    viewBox: "0 0 647 783",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1561_11070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M560.846 644.16C510.759 611.252 401.966 453.671 401.966 453.671L391.034 460.83C391.034 460.83 525.187 651.299 563.882 659.967L560.846 644.16Z",
    fill: "#F3E600",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 699.117C446.327 630.709 358.24 482.306 358.24 482.306L369.172 475.148C369.172 475.148 486.733 667.453 486.275 708.219L473 699.117Z",
    fill: "#F3E600",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.081 477.171L389.974 461.525C389.974 461.525 506.114 646.126 549.283 655.687C592.451 665.248 509.004 666.642 509.004 666.642L487.042 704.157C487.042 704.157 448.053 597.416 428.151 564.711C394.352 509.273 366.127 477.141 366.127 477.141L366.081 477.171Z",
    fill: "#C80923",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.756 459.048C393.756 459.048 504.267 629.014 564.402 659.956L561.969 673.148C561.969 673.148 520.998 658.589 384.639 464.952L393.725 459.002L393.756 459.048Z",
    fill: "#F54E1D",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.573 477.503C365.573 477.503 476.384 646.416 483.456 706.834L493.482 713.186C493.482 713.186 460.728 599.463 374.66 471.553L365.573 477.503Z",
    fill: "#F54E1D",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M435.141 527.378C430.616 514.128 428.737 502.705 428.296 493.174C411.862 470.192 400.921 454.29 400.921 454.29L357.194 482.924C357.194 482.924 417.19 579.071 452.6 650.656C459.997 640.012 472.772 631.844 475.663 613.211C480.003 585.72 450.505 572.479 435.064 527.362L435.141 527.378Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.914 457.668L452.194 465.661C453.822 475.996 449.745 486.377 441.511 492.824C427.751 503.614 405.103 520.356 382.371 532.342C372.972 537.311 361.584 536.728 352.748 530.783L346.117 526.294L450.914 457.668Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M434.52 483.759C420.76 494.549 398.112 511.292 375.381 523.278C367.287 527.523 357.804 527.736 349.715 523.938L345.379 526.777L352.009 531.267C360.845 537.212 372.233 537.795 381.633 532.826C404.411 520.81 427.013 504.097 440.773 493.307C449.007 486.86 453.084 476.48 451.456 466.144L450.176 458.151L445.564 461.172C445.538 469.888 441.524 478.25 434.566 483.729L434.52 483.759Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.136 432.293L454.911 444.044C455.496 452.888 451.632 461.481 444.615 466.867C427.009 480.44 391.467 506.68 357.848 524.28C349.938 528.405 340.442 528.296 332.664 523.966L322.602 518.362L454.152 432.217L454.136 432.293Z",
    fill: "#00FF9F",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.291 283.646L427.463 295.146C447 299.619 464.187 310.97 475.982 327.17C497.802 357.169 533.12 408.184 551.812 448.603C556.725 459.226 546.036 470.378 535.184 465.884L454.076 432.201L377.291 283.646Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M453.683 431.602L534.792 465.285C545.643 469.779 556.332 458.627 551.419 448.004C547.572 439.714 543.026 430.96 538.068 422.081C536.676 429.516 528.603 435.001 520.434 431.585L439.325 397.902L453.683 431.602Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.739 482.253C423.644 462.015 453.945 433.209 453.945 433.209C453.945 433.209 331.558 176.973 281.753 133.928C231.949 90.8834 134.182 87.4183 134.182 87.4183C134.182 87.4183 98.3069 178.464 117.853 241.324C137.4 304.183 320.426 518.864 320.426 518.864C320.426 518.864 361.865 502.537 392.723 482.329L392.739 482.253Z",
    fill: "#E6E6E6",
    stroke: "#3F3D56",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.528 95.583C174.707 109.651 207.242 131.053 233.499 158.871C259.079 187.265 277.352 220.906 297.979 252.807C337.359 317.573 375.602 383.018 411.771 449.623C371.883 385.19 333.348 320.002 293.506 255.538C273.46 223.718 255.018 190.122 230.541 161.599C205.355 133.606 173.683 111.508 139.605 95.5989L139.528 95.583Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.716 340.147C282.216 317.501 316.254 289.873 351.503 263.891C320.285 294.417 285.123 322.847 244.716 340.147Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.341 243.066C279.341 243.066 291.755 252.863 258.178 304.245C224.602 355.626 265.622 367.845 265.622 367.845C265.622 367.845 258.256 320.868 268.531 313.612C268.531 313.612 277.555 348.629 292.749 369.919C307.943 391.209 385.728 486.845 385.728 486.845L320.773 519.495C320.773 519.495 314.414 494.99 295.406 470.794C240.591 400.977 129.372 263.241 126.219 239.405C122.002 207.302 116.169 130.059 133.49 95.3192C133.49 95.3192 155.132 210.19 177.147 236.964C199.162 263.739 279.341 243.066 279.341 243.066Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.715 110.321C131.715 110.321 123.145 177.95 149.992 230.823C176.839 283.695 235.684 361.681 235.684 361.681C235.684 361.681 159.137 249.417 153.404 226.875C147.671 204.332 130.843 147.536 131.715 110.321Z",
    fill: "#A6A5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.975 299.768C429.391 302.319 463.636 314.758 476.444 343.475C458.404 318.645 428.086 308.578 399.975 299.768Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.564 435.19C471.297 439.377 455.254 434 452.389 429.022L427.503 379.545L377.245 283.677C377.245 283.677 433.245 374.928 460.783 405.005C467.498 412.34 471.78 421.596 473.059 431.501L473.518 435.221L473.564 435.19Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.785 93.7998C147.785 93.7998 240.933 110.241 279.281 153.604C317.584 196.998 391.554 325.053 391.554 325.053C391.554 325.053 349.554 223.778 296.976 162.711C244.399 101.644 207.57 105.99 147.831 93.7696L147.785 93.7998Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M267.325 285.403C291.933 269.288 298.819 236.276 282.704 211.668C266.589 187.059 233.577 180.174 208.968 196.289C184.36 212.403 177.475 245.416 193.589 270.024C209.704 294.632 242.717 301.518 267.325 285.403Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.714 442.756C310.223 439.803 311.485 433.754 308.532 429.245C305.579 424.736 299.531 423.474 295.022 426.427C290.513 429.38 289.251 435.429 292.204 439.938C295.156 444.447 301.205 445.708 305.714 442.756Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.676 421.014C287.918 419.546 288.545 416.538 287.077 414.297C285.609 412.055 282.602 411.428 280.36 412.896C278.118 414.364 277.491 417.371 278.959 419.613C280.427 421.854 283.434 422.482 285.676 421.014Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.404 430.821C273.009 429.77 273.458 427.617 272.407 426.012C271.356 424.407 269.203 423.958 267.598 425.009C265.993 426.06 265.544 428.213 266.595 429.818C267.646 431.423 269.799 431.872 271.404 430.821Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.807 375.437C236.285 374.469 236.698 372.487 235.73 371.009C234.763 369.532 232.781 369.118 231.303 370.086C229.826 371.054 229.412 373.036 230.38 374.513C231.347 375.991 233.33 376.404 234.807 375.437Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.723 360.472C222.557 359.271 223.071 356.811 221.87 354.976C220.668 353.142 218.208 352.629 216.374 353.83C214.54 355.031 214.026 357.492 215.228 359.326C216.429 361.16 218.889 361.673 220.723 360.472Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.52 300.678C344.73 298.576 345.628 294.27 343.526 291.06C341.424 287.851 337.118 286.953 333.908 289.054C330.699 291.156 329.801 295.462 331.903 298.672C334.004 301.882 338.31 302.78 341.52 300.678Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.185 315.438C352.79 314.387 353.239 312.234 352.188 310.629C351.137 309.024 348.984 308.575 347.38 309.626C345.775 310.677 345.326 312.83 346.377 314.435C347.428 316.04 349.58 316.489 351.185 315.438Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M244.716 340.147C244.716 340.147 275.106 337.843 288.269 341.943C301.433 346.042 299.707 345.722 322.093 338.642C344.478 331.563 354.827 326.433 353.192 305.821C351.557 285.209 351.503 263.891 351.503 263.891L299.249 306.677L244.716 340.147Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.25 400.106C500.74 397.82 501.716 393.138 499.431 389.648C497.145 386.158 492.463 385.182 488.973 387.467C485.483 389.753 484.507 394.435 486.792 397.925C489.078 401.415 493.76 402.391 497.25 400.106Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.263 383.534C493.486 382.733 493.828 381.093 493.027 379.87C492.227 378.647 490.586 378.305 489.363 379.106C488.141 379.907 487.799 381.547 488.599 382.77C489.4 383.992 491.04 384.335 492.263 383.534Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.253 389.757L205.738 440.343C202.028 460.039 205.562 480.331 215.696 497.618C234.472 529.611 267.115 582.378 296.692 615.668C304.465 624.418 318.96 619.078 319.179 607.336L320.727 519.524L215.253 389.757Z",
    fill: "#3F3D56",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.961 416.994C217.799 446.283 214.861 478.128 230.456 504.56C209.253 481.34 211.54 444.978 220.961 416.994Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.28 533.723C276.77 531.438 277.747 526.756 275.461 523.266C273.176 519.776 268.494 518.799 265.004 521.085C261.514 523.37 260.537 528.052 262.823 531.542C265.108 535.032 269.79 536.008 273.28 533.723Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.129 522.498C261.352 521.697 261.694 520.057 260.894 518.834C260.093 517.611 258.452 517.269 257.23 518.07C256.007 518.87 255.665 520.511 256.465 521.734C257.266 522.956 258.907 523.298 260.129 522.498Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M319.642 519.378L318.094 607.189C317.875 618.932 303.379 624.272 295.606 615.522C289.546 608.682 283.339 601.016 277.182 592.921C284.554 594.618 292.809 589.41 292.943 580.557L294.491 492.746L319.642 519.378Z",
    fill: "#272735"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M191.699 174.446C161.498 192.839 130.656 207.434 113.233 213.637C113.267 216.91 113.347 220.153 113.626 223.397C127.485 219.198 156.035 208.148 184.89 191.624C189.192 189.137 193.541 186.619 197.875 183.978C226.355 166.58 253.39 144.461 268.759 124.049C266.003 122.559 263.185 121.174 260.352 119.867C244.535 138.99 218.334 158.256 191.683 174.522L191.699 174.446Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.917 164.63C166.388 163.012 167.079 159.697 165.461 157.226C163.843 154.755 160.528 154.063 158.057 155.681C155.586 157.3 154.895 160.614 156.513 163.086C158.131 165.557 161.446 166.248 163.917 164.63Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.649 162.693C164.05 161.775 164.442 159.896 163.524 158.495C162.607 157.094 160.727 156.701 159.326 157.619C157.925 158.536 157.533 160.416 158.45 161.817C159.368 163.218 161.247 163.61 162.649 162.693Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.083 177.193C139.554 175.575 140.245 172.26 138.627 169.789C137.009 167.318 133.694 166.627 131.223 168.245C128.752 169.863 128.061 173.178 129.679 175.649C131.297 178.12 134.612 178.811 137.083 177.193Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.815 175.256C137.216 174.339 137.608 172.459 136.69 171.058C135.773 169.657 133.893 169.265 132.492 170.182C131.091 171.1 130.699 172.98 131.616 174.381C132.534 175.782 134.413 176.174 135.815 175.256Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.047 148.573C192.518 146.955 193.209 143.64 191.591 141.169C189.973 138.698 186.658 138.007 184.187 139.625C181.716 141.243 181.025 144.558 182.643 147.029C184.261 149.5 187.576 150.191 190.047 148.573Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.778 146.636C190.18 145.719 190.572 143.839 189.654 142.438C188.737 141.037 186.857 140.645 185.456 141.562C184.055 142.48 183.663 144.359 184.58 145.761C185.498 147.162 187.377 147.554 188.778 146.636Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.405 129.529C217.876 127.911 218.568 124.596 216.95 122.125C215.331 119.654 212.016 118.963 209.545 120.581C207.074 122.199 206.383 125.514 208.001 127.985C209.619 130.456 212.934 131.147 215.405 129.529Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.137 127.592C215.538 126.675 215.93 124.795 215.012 123.394C214.095 121.993 212.215 121.601 210.814 122.518C209.413 123.436 209.021 125.315 209.939 126.717C210.856 128.118 212.736 128.51 214.137 127.592Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.389 429.022C452.389 429.022 395.365 484.553 349.68 500.234",
    stroke: "#3F3D56",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M397.229 501.589L442.361 469.464C443.269 468.737 444.162 468.087 444.978 467.421C451.472 462.443 455.22 454.782 455.318 446.678C440.102 450.315 420.403 458.074 405.877 474.639C397.926 483.733 387.972 500.335 375.571 515.113C382.932 510.754 390.172 506.21 397.153 501.573L397.229 501.589Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.526 564.272C445.526 564.272 428.408 499.888 371.955 413.679C320.062 334.435 297.674 332.554 294.37 332.741C294.125 332.769 293.864 332.874 293.679 332.995C293.679 332.995 293.295 333.313 293.17 333.526C291.648 336.434 284.453 357.754 336.346 436.998C392.8 523.206 444.973 564.634 444.973 564.634L445.572 564.242L445.526 564.272Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.256 456.663C372.625 458.583 374.434 469.196 376.293 477.469C376.957 480.395 373.013 482.122 371.352 479.585C367.063 473.035 363.862 462.411 371.152 448.081C378.442 433.751 366.932 436.806 365.502 434.118C365.32 433.841 365.109 433.519 364.928 433.242C364.898 433.196 362.86 429.983 362.702 425.011C362.552 420.958 359.168 417.703 355.1 417.731C346.414 417.751 332.07 415.875 323.233 404.394C313.596 391.79 299.712 352.573 292.877 332.071C292.646 332.222 292.492 332.389 292.368 332.602C290.845 335.511 283.651 356.83 335.543 436.074C391.997 522.282 444.17 563.71 444.17 563.71L444.77 563.318C444.77 563.318 444.533 562.352 443.967 560.482C434.074 547.387 400.462 502.701 392.436 491.151C383.006 477.555 375.333 456.679 375.333 456.679L375.256 456.663Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.118 406.634C356.143 403.999 357.269 398.599 354.633 394.574C351.998 390.549 346.598 389.423 342.573 392.059C338.548 394.694 337.422 400.094 340.058 404.119C342.693 408.144 348.093 409.27 352.118 406.634Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M294.833 334.152C294.833 334.152 294.327 334.285 294.142 334.406C293.958 334.527 293.758 334.724 293.633 334.937C292.809 336.597 290.117 344.16 297.364 364.788C297.488 364.575 297.642 364.408 297.827 364.287C298.057 364.136 298.272 364.061 298.517 364.033C301.791 363.8 324.209 365.727 376.102 444.971C406.368 491.189 425.323 531.105 436.385 558.263C442.108 563.479 445.359 566.029 445.359 566.029L445.959 565.637C445.959 565.637 428.841 501.253 372.388 415.044C320.495 335.8 298.107 333.919 294.802 334.106L294.833 334.152Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.939 400.863C332.467 399.862 332.895 397.812 331.894 396.284C330.893 394.755 328.843 394.327 327.314 395.328C325.786 396.329 325.358 398.38 326.359 399.908C327.36 401.437 329.411 401.864 330.939 400.863Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.279 389.392C337.578 388.541 337.942 386.798 337.091 385.499C336.24 384.2 334.497 383.836 333.198 384.687C331.899 385.538 331.535 387.281 332.386 388.58C333.237 389.879 334.98 390.243 336.279 389.392Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.497 391.096C322.236 427.125 346.198 458.886 370.947 489.735C343.301 461.507 318.645 428.686 305.497 391.096Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M402.962 332.61C402.962 332.61 378.506 312.574 380.485 332.302C382.463 352.03 388.074 344.797 395.02 376.036C401.966 407.274 412.332 398.245 420.211 414.504C428.09 430.764 411.94 429.148 407.669 438.93C403.399 448.713 398.779 459.976 406.168 467.132C413.556 474.289 450.487 424.204 450.487 424.204L402.916 332.64L402.962 332.61Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.366 430.183C413.378 428.865 413.941 426.165 412.623 424.153C411.305 422.14 408.606 421.577 406.593 422.895C404.581 424.213 404.018 426.913 405.335 428.925C406.653 430.938 409.353 431.501 411.366 430.183Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.651 399.657C391.313 399.223 391.498 398.335 391.065 397.673C390.631 397.01 389.742 396.825 389.08 397.259C388.418 397.692 388.232 398.581 388.666 399.243C389.1 399.906 389.988 400.091 390.651 399.657Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.062 282.155L296.441 281.758L293.724 279.32C292.449 278.178 290.378 278.941 290.18 280.652L289.784 284.273L287.345 286.99C286.203 288.265 286.966 290.336 288.677 290.533L292.298 290.93L295.015 293.369C296.29 294.511 298.361 293.748 298.559 292.037L298.955 288.416L301.394 285.699C302.536 284.424 301.773 282.353 300.062 282.155Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.531 303.813C291.34 302.629 291.846 300.203 290.661 298.394C289.477 296.585 287.05 296.079 285.242 297.264C283.433 298.448 282.927 300.874 284.111 302.683C285.296 304.492 287.722 304.998 289.531 303.813Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.635 639.782C493.278 637.396 494.297 632.509 491.912 628.866C489.526 625.224 484.639 624.204 480.996 626.59C477.354 628.975 476.334 633.862 478.72 637.505C481.105 641.148 485.992 642.167 489.635 639.782Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.619 626.362C478.867 625.545 479.216 623.871 478.399 622.622C477.581 621.374 475.907 621.025 474.659 621.842C473.41 622.66 473.061 624.334 473.878 625.582C474.696 626.831 476.37 627.18 477.619 626.362Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.976 588.654C440.287 586.485 441.214 582.043 439.045 578.731C436.877 575.419 432.434 574.493 429.122 576.661C425.811 578.83 424.884 583.273 427.053 586.584C429.221 589.896 433.664 590.823 436.976 588.654Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.826 599.746C434.896 599.045 435.195 597.61 434.495 596.54C433.794 595.47 432.359 595.17 431.289 595.871C430.219 596.572 429.92 598.007 430.62 599.077C431.321 600.147 432.756 600.446 433.826 599.746Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.484 551.858C465.452 551.224 465.723 549.925 465.089 548.957C464.455 547.989 463.156 547.718 462.188 548.352C461.22 548.986 460.949 550.285 461.583 551.253C462.217 552.221 463.516 552.492 464.484 551.858Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.159 557.89C469.771 557.49 469.942 556.67 469.542 556.059C469.141 555.447 468.321 555.276 467.71 555.676C467.098 556.077 466.927 556.897 467.327 557.508C467.728 558.12 468.548 558.291 469.159 557.89Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.307 279.181C282.916 263.067 289.801 230.054 273.686 205.446C257.572 180.838 224.559 173.952 199.951 190.067C175.343 206.182 168.457 239.194 184.572 263.802C200.687 288.411 233.699 295.296 258.307 279.181Z",
    fill: "#E6E6E6",
    stroke: "#3F3D56",
    strokeWidth: 0.74,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.933 276.984C280.472 261.57 287.058 229.992 271.644 206.454C256.23 182.916 224.653 176.33 201.114 191.744C177.576 207.158 170.99 238.735 186.404 262.273C201.818 285.812 233.395 292.398 256.933 276.984Z",
    stroke: "#04DAF6",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.685 200.552C208.34 199.467 208.804 197.246 207.719 195.59C206.635 193.934 204.414 193.471 202.758 194.555C201.102 195.64 200.639 197.861 201.723 199.517C202.807 201.173 205.029 201.636 206.685 200.552Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.315 274.813C256.971 273.729 257.435 271.508 256.35 269.852C255.266 268.196 253.045 267.733 251.389 268.817C249.733 269.901 249.27 272.123 250.354 273.778C251.438 275.434 253.66 275.898 255.315 274.813Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.131 213.367C269.787 212.283 270.25 210.061 269.166 208.405C268.081 206.75 265.86 206.286 264.204 207.371C262.548 208.455 262.085 210.676 263.169 212.332C264.254 213.988 266.475 214.451 268.131 213.367Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.869 261.998C195.525 260.914 195.988 258.692 194.904 257.036C193.82 255.38 191.598 254.917 189.942 256.002C188.287 257.086 187.823 259.307 188.908 260.963C189.992 262.619 192.213 263.082 193.869 261.998Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.059 194.25C241.714 193.165 242.178 190.944 241.093 189.288C240.009 187.632 237.788 187.169 236.132 188.253C234.476 189.338 234.013 191.559 235.097 193.215C236.181 194.871 238.403 195.334 240.059 194.25Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.941 281.115C223.597 280.031 224.061 277.809 222.976 276.153C221.892 274.498 219.671 274.034 218.015 275.119C216.359 276.203 215.896 278.424 216.98 280.08C218.064 281.736 220.286 282.199 221.941 281.115Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.432 246.741C276.088 245.657 276.551 243.435 275.466 241.779C274.382 240.124 272.161 239.66 270.505 240.745C268.849 241.829 268.386 244.05 269.47 245.706C270.554 247.362 272.776 247.825 274.432 246.741Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.567 228.624C189.223 227.539 189.687 225.318 188.602 223.662C187.518 222.006 185.297 221.543 183.641 222.627C181.985 223.712 181.522 225.933 182.606 227.589C183.69 229.245 185.912 229.708 187.567 228.624Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.733 264.56C265.266 253.733 269.892 231.554 259.065 215.021C248.238 198.488 226.059 193.862 209.526 204.689C192.993 215.515 188.367 237.695 199.194 254.227C210.021 270.76 232.2 275.386 248.733 264.56Z",
    fill: "#3F3D56",
    stroke: "#3F3D56",
    strokeWidth: 0.59,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.816 201.629L211.715 265.799C216.753 268.762 222.458 270.43 228.252 270.722L233.931 199.384C228.247 198.756 222.37 199.442 216.816 201.629Z",
    fill: "#00FF9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.092 199.885L231.478 270.719C232.763 270.668 234.064 270.541 235.305 270.322L240.831 200.864C239.595 200.487 238.39 200.155 237.092 199.885Z",
    fill: "#00FF9F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M256.66 228.459C245.923 256.646 245.823 268.772 225.558 272.749C212.769 275.259 199.298 273.206 191.116 271.38C208.651 288.698 236.455 292.107 257.95 278.032C281.935 262.325 289.154 230.576 274.66 206.127C268.609 209.166 261.63 215.516 256.691 228.505L256.66 228.459Z",
    fill: "#272735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.504 120.098C253.44 116.155 246.006 112.653 238.355 109.624C227.57 126.769 210.973 138.561 180.88 158.729C152.309 177.9 121.123 189.556 112.06 190.812C111.78 198.838 111.897 206.867 112.597 214.779C127.895 210.363 162.525 198.231 193.459 178.039C226.531 156.382 246.058 139.905 260.488 120.174L260.504 120.098Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M187.373 168.646C158.556 186.132 129.005 199.882 112.366 205.571C112.493 208.784 112.619 211.996 112.945 215.21C126.25 211.374 153.601 201.109 181.21 185.401C185.328 183.034 189.492 180.637 193.642 178.117C220.83 161.565 246.482 140.352 260.882 120.575C258.172 119.054 255.447 117.609 252.659 116.271C237.765 134.79 212.855 153.211 187.404 168.692L187.373 168.646Z",
    fill: "#3F3D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1561_11070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 317.195,
    height: 727.458,
    fill: "white",
    transform: "translate(0 173.771) rotate(-33.2187)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket2);
export default __webpack_public_path__ + "static/media/rocket_2.b57794ded43520fa450abced38402407.svg";
export { ForwardRef as ReactComponent };